import { FilterSelectionState } from "@/filters/selection/FilterSelectionState";
import { Degree } from "@/models/Degree";
import { ISeoMetaDataInfo } from "../ISeoMetaDataInfo";
import { FilterKey } from "@studyportals/search-filters";
import { SeoMetaDataHandlerDefaultSort } from "../SeoMetaDataHandlerDefaultSort";

export default class Continent extends SeoMetaDataHandlerDefaultSort {
	protected async canHandleWithDefaultSorting(filterSelectionState: FilterSelectionState): Promise<boolean> {
		return await this.singleSelectionFor(FilterKey.CONTINENT, filterSelectionState)
			&& await this.selectionOnlyFor([FilterKey.CONTINENT], filterSelectionState);
	}

	protected async selfHandle(degree: Degree, filterSelectionState: FilterSelectionState): Promise<ISeoMetaDataInfo> {
		const portalName = degree.toPortalName();

		const continent = this.getFilterOptionNameBy(FilterKey.CONTINENT, filterSelectionState);

		const seoInfo = {
			title: `Complete list of universities in ${continent} | ${portalName}`,

			description: `Interested in studying in ${continent}? ` +
				`Check out our list of universities in ${continent} to filter and ` +
				`select your university by country, city, attendance and more.`
		};

		return Promise.resolve(seoInfo);
	}
}